import React, { useEffect, useState } from "react";
import { Search, Bell } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Topbar({ title, subtitle, right }) {
  const { user } = useAuth();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(t);
  }, []);

  return (
    <header
      className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-slate-200 bg-white px-6"
      data-testid="topbar"
    >
      <div className="min-w-0">
        <h1 className="truncate font-display text-lg font-semibold tracking-tight text-navy-600" data-testid="topbar-title">
          {title}
        </h1>
        {subtitle && (
          <div className="truncate text-xs uppercase tracking-[0.18em] text-slate-500">
            {subtitle}
          </div>
        )}
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden items-center gap-2 rounded-sm border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm text-slate-500 md:flex">
          <Search className="h-4 w-4 text-slate-400" />
          <input
            className="w-64 bg-transparent outline-none placeholder:text-slate-400"
            placeholder="Search records, categories, companies…"
            data-testid="topbar-search"
          />
          <kbd className="rounded-sm border border-slate-200 bg-white px-1.5 py-0.5 text-[10px] text-slate-400">
            ⌘K
          </kbd>
        </div>

        <div className="hidden text-right md:block">
          <div className="text-xs font-medium text-navy-600 tabular">
            {now.toLocaleDateString("en-US", {
              weekday: "short",
              month: "short",
              day: "numeric",
            })}
          </div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500">
            {user?.companyAccess?.length ?? 0} companies · live
          </div>
        </div>

        <button
          className="relative flex h-9 w-9 items-center justify-center rounded-sm border border-slate-200 text-slate-500 transition-colors hover:border-navy-600 hover:text-navy-600"
          data-testid="topbar-notifications"
          type="button"
        >
          <Bell className="h-4 w-4" />
          <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-brand-orange" />
        </button>

        {right}
      </div>
    </header>
  );
}
